import { lazy } from 'react';

// project imports
import Loadable from 'ui-component/Loadable';
import { COMPONENT_TYPE } from 'views/pages/dashboard/Pricings/pricing-constants';
import UpdatePlan from 'views/pages/dashboard/UpdatePlan';
import ActivityLog from 'views/pages/activityLog';
import { MODULE } from 'constants';
import SignInCard from 'views/pages/dashboard/CompanyProfile/IntegrateDiolog/DiologMenu/EmailIntegration.js/SignInCard';
import Auth from 'Components/ExtensionAuth/auth';
import ConsentOtp from 'Components/ExtensionAuth/auth/consent/otp';

// login option 3 routing
const AuthLogin3 = Loadable(lazy(() => import('views/pages/authentication/authentication3/Login3')));
const AuthRegister3 = Loadable(lazy(() => import('views/pages/authentication/authentication3/Register3')));
const ForgotPassword = Loadable(lazy(() => import('views/pages/authentication/authentication3/ForgotPassword')));
const NotFoundPage = Loadable(lazy(() => import('views/pages/NotFoundPage')));
// ==============================|| AUTHENTICATION ROUTING ||============================== //
const StripeSuccess = Loadable(lazy(() => import('views/pages/StripePayment/Success')));
const StripeError = Loadable(lazy(() => import('views/pages/StripePayment/Cancel')));
const InviteTeam = Loadable(lazy(() => import('views/pages/dashboard/InviteTeam')));
const InviteTeamGuard = Loadable(lazy(() => import('Components/InviteTeamGuard')));
const LoggedInWrapperGuard = Loadable(lazy(() => import('Components/LoggedInWrapper')));
const SubscriptionPricingWrapper = Loadable(lazy(() => import('Components/SubscriptionPricingWrapper')));
const Pricing = Loadable(lazy(() => import('views/pages/dashboard/Pricings')));
const Toast = Loadable(lazy(() => import('Components/Toast')));

const AuthenticationRoutes = {
    path: '/',
    children: [
        {
            path: '/',
            element: <AuthLogin3 />
        },
        {
            path: '/dashboard/invite-team',
            element: (
                <ActivityLog module={MODULE.inviteTeam}>
                    <LoggedInWrapperGuard>
                        <InviteTeamGuard>
                            <InviteTeam />
                            <Toast />
                        </InviteTeamGuard>
                    </LoggedInWrapperGuard>
                </ActivityLog>
            )
        },
        {
            path: '/dashboard/update-plan',
            element: (
                <ActivityLog module={MODULE.updatePlan}>
                    <>
                        <UpdatePlan />
                        <Toast />
                    </>
                </ActivityLog>
            )
        },
        {
            path: '/register',
            element: (
                <ActivityLog module={MODULE.register} isAuth>
                    <AuthRegister3 />
                </ActivityLog>
            )
        },
        {
            path: '/dashboard/plan',
            element: (
                <ActivityLog module={MODULE.plan} isAuth>
                    <LoggedInWrapperGuard>
                        <SubscriptionPricingWrapper>
                            <Pricing componentType={COMPONENT_TYPE.ADD} />
                            <Toast />
                        </SubscriptionPricingWrapper>
                    </LoggedInWrapperGuard>
                </ActivityLog>
            )
        },
        {
            path: '/register/:token',
            element: (
                <ActivityLog module={MODULE.register} isAuth>
                    <AuthRegister3 />
                </ActivityLog>
            )
        },
        {
            path: '/forgot-password/:token',
            element: (
                <ActivityLog module={MODULE.ForgotPassword} isAuth>
                    <ForgotPassword />
                </ActivityLog>
            )
        },
        {
            path: '/forgot-password',
            element: (
                <ActivityLog module={MODULE.StripeSuccess} isAuth>
                    <ForgotPassword />
                </ActivityLog>
            )
        },
        {
            path: '/success',
            element: (
                <ActivityLog module={MODULE.StripeSuccess} isAuth>
                    <StripeSuccess />
                </ActivityLog>
            )
        },
        {
            path: '/error',
            element: (
                <ActivityLog module={MODULE.StripeError}>
                    <StripeError />
                </ActivityLog>
            )
        },
        {
            path: '/*',
            element: (
                <ActivityLog module={MODULE.Forbidden}>
                    <NotFoundPage />
                </ActivityLog>
            )
        },
        {
            path: '/sign-in-extension',
            element: (
                <ActivityLog module={MODULE.SignInIntegration}>
                    <SignInCard />
                    <Toast />
                </ActivityLog>
            )
        },
        {
            path: '/redirect-sign-in-extension',
            element: (
                <ActivityLog module={MODULE.SignInIntegration}>
                    <Auth />
                </ActivityLog>
            )
        },
        {
            path: '/user-consent/:id/:email',
            element: (
                <ActivityLog module={MODULE.SignInIntegration}>
                    <ConsentOtp />
                </ActivityLog>
            )
        }
    ]
};

export default AuthenticationRoutes;
